module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('table', {
    staticClass: "t1"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "124"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "124"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "62"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "62"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "124"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "124"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "62"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "62"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "124"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "124"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "124"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "21px",
      "font-weight": "bold",
      "font-family": "宋体"
    },
    attrs: {
      "colspan": "11"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "21px",
      "font-weight": "bold",
      "font-family": "宋体"
    },
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("听课记录表")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v(_vm._s(_vm.getSemesterName()))])]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("授课教师")]), _vm._v(" "), _c('td', {
    staticClass: "c1",
    attrs: {
      "colspan": "2"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "teaCode",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.teaChange
    },
    model: {
      value: (_vm.form.teaCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "teaCode", $$v)
      },
      expression: "form.teaCode"
    }
  }, _vm._l((_vm.comboOption.tea), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "c1",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("教师所在系部")]), _vm._v(" "), _c('td', {
    staticClass: "c1",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.form.deptName))]), _vm._v(" "), _c('td', {
    staticClass: "c1",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("听课日期")]), _vm._v(" "), _c('td', {
    staticClass: "c1",
    attrs: {
      "colspan": "2"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "date",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c2"
  }, [_vm._v("授课班级")]), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.form.className))]), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("授课地点")]), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "2"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "site",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.form.site),
      callback: function($$v) {
        _vm.$set(_vm.form, "site", $$v)
      },
      expression: "form.site"
    }
  }, _vm._l((_vm.comboOption.site), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("听课节次")]), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "2"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "time",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "multiple-limit": 3,
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.form.time),
      callback: function($$v) {
        _vm.$set(_vm.form, "time", $$v)
      },
      expression: "form.time"
    }
  }, _vm._l((_vm.comboOption.time), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c2"
  }, [_vm._v("课程名称")]), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "4"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "courseCode",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "change": _vm.courseChange
    },
    model: {
      value: (_vm.form.courseCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "courseCode", $$v)
      },
      expression: "form.courseCode"
    }
  }, _vm._l((_vm.comboOption.course), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    }, [_c('div', {
      attrs: {
        "slot": ""
      },
      slot: "default"
    }, [_vm._v(_vm._s(item.className + " - (" + item.comboName + ")"))])])
  }), 1)], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("课题")]), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "4"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "kt",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "500"
    },
    model: {
      value: (_vm.form.kt),
      callback: function($$v) {
        _vm.$set(_vm.form, "kt", $$v)
      },
      expression: "form.kt"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c2",
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("到课情况")]), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("教师情况")]), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("学生情况")])]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c2",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("按时上课"), _c('br'), _vm._v("（√）")]), _vm._v(" "), _c('td', {
    staticClass: "c3",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("迟到"), _c('br'), _vm._v("（分钟）")]), _vm._v(" "), _c('td', {
    staticClass: "c1",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("提前下课"), _c('br'), _vm._v("（分钟）")]), _vm._v(" "), _c('td', {
    staticClass: "c1",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("应到"), _c('br'), _vm._v("人数")]), _vm._v(" "), _c('td', {
    staticClass: "c1",
    attrs: {
      "colspan": "2",
      "rowspan": "2"
    }
  }, [_vm._v("实到"), _c('br'), _vm._v("人数")]), _vm._v(" "), _c('td', {
    staticClass: "c1",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("迟到"), _c('br'), _vm._v("人数")]), _vm._v(" "), _c('td', {
    staticClass: "c4"
  }, [_vm._v("迟到最长"), _c('br'), _vm._v("（分钟）")]), _vm._v(" "), _c('td', {
    staticClass: "c4"
  }, [_vm._v("早退"), _c('br'), _vm._v("人数")])]), _vm._v(" "), _c('tr', {
    staticClass: "r1",
    staticStyle: {
      "height": "0"
    }
  }, [_c('td', {
    staticClass: "c5",
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "c2"
  }), _vm._v(" "), _c('td', {
    staticClass: "c2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c2"
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "assk"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.form.assk),
      callback: function($$v) {
        _vm.$set(_vm.form, "assk", $$v)
      },
      expression: "form.assk"
    }
  })], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "2"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "cd",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.cd),
      callback: function($$v) {
        _vm.$set(_vm.form, "cd", $$v)
      },
      expression: "form.cd"
    }
  })], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "c2"
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "tqxk",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.tqxk),
      callback: function($$v) {
        _vm.$set(_vm.form, "tqxk", $$v)
      },
      expression: "form.tqxk"
    }
  })], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "c2"
  }, [_vm._v(_vm._s(_vm.form.ydxss))]), _vm._v(" "), _c('td', {
    staticClass: "c2",
    attrs: {
      "colspan": "2"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "sdrs",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.sdrs),
      callback: function($$v) {
        _vm.$set(_vm.form, "sdrs", $$v)
      },
      expression: "form.sdrs"
    }
  })], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "c2"
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "cdrs",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.cdrs),
      callback: function($$v) {
        _vm.$set(_vm.form, "cdrs", $$v)
      },
      expression: "form.cdrs"
    }
  })], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "c2"
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "cdrs",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.cdzc),
      callback: function($$v) {
        _vm.$set(_vm.form, "cdzc", $$v)
      },
      expression: "form.cdzc"
    }
  })], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "c2"
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "ztrs",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.form.ztrs),
      callback: function($$v) {
        _vm.$set(_vm.form, "ztrs", $$v)
      },
      expression: "form.ztrs"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "r2"
  }, [_c('td', {
    staticClass: "c6",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("授课过程记录")])]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c10",
    attrs: {
      "colspan": "11"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "skgcjl",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 15,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.skgcjl),
      callback: function($$v) {
        _vm.$set(_vm.form, "skgcjl", $$v)
      },
      expression: "form.skgcjl"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c8",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("教学建议")])]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c10",
    attrs: {
      "colspan": "11"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "jxjy",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 15,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.jxjy),
      callback: function($$v) {
        _vm.$set(_vm.form, "jxjy", $$v)
      },
      expression: "form.jxjy"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c7",
    attrs: {
      "colspan": "11"
    }
  }, [_c('span', [_vm._v("评价等级（勾选）：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "pjdj",
      "rules": [{
        required: true,
        message: '请选择评价登记'
      }]
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.pjdj),
      callback: function($$v) {
        _vm.$set(_vm.form, "pjdj", $$v)
      },
      expression: "form.pjdj"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "A"
    }
  }, [_vm._v("优秀")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "B"
    }
  }, [_vm._v("良好")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "C"
    }
  }, [_vm._v("中等")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "D"
    }
  }, [_vm._v("合格")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "E"
    }
  }, [_vm._v("不合格")])], 1)], 1)], 1)])]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c9"
  })])])])]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "t1"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "70"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "1046"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c1",
    staticStyle: {
      "font-weight": "bold",
      "font-family": "宋体"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("公共基础课程参考指标")])]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("目标"), _c('br'), _vm._v("与"), _c('br'), _vm._v("学情")]), _vm._v(" "), _c('td', {
    staticClass: "c11"
  }, [_vm._v("1.符合新时代对技术技能人才培养新要求，落实教育部颁布的公共基础课程教学标准有关要求，紧扣学校专业人才培养方案和课程教学安排，夯实学生科学文化基础，着力培养学生人文素养、职业素养、信息素养，培养学生工匠精神、科学精神、创新精神和终身学习能力。"), _c('br'), _vm._v("2.教学目标表述明确、相互关联，重点突出、可评可测。"), _c('br'), _vm._v("3.客观分析学生知识基础、认知能力、学习特点、专业特性等，详实反映学生整体情况与个体差异，准确预判教学难点。")])]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("内容"), _c('br'), _vm._v("与"), _c('br'), _vm._v("策略")]), _vm._v(" "), _c('td', {
    staticClass: "c11"
  }, [_vm._v("1.思政课程按照“八个相统一”要求扎实推进创优建设；其他课程注重落实课程思政要求，结合课程特点挖掘思政元素，有机融入课程教学，达到润物无声的育人效果。"), _c('br'), _vm._v("2.教学内容落实公共基础课程课标，突出思想性、科学性、基础性、职业性和时代性，有效支撑教学目标的实现，内容选择科学严谨、容量适度，安排合理、衔接有序、结构清晰，符合层次定位。"), _c('br'), _vm._v("3.教材选用、使用符合《职业院校教材管理办法》等文件规定和要求，配套提供丰富、优质学习资源；教案完整、规范、简明、真实。"), _c('br'), _vm._v("4.教学设计科学合理，教学过程系统优化，流程环节构思得当，技术应用预想合理，方法手段设计恰当，评价考核科学有效。")])]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("实施"), _c('br'), _vm._v("与"), _c('br'), _vm._v("成效")]), _vm._v(" "), _c('td', {
    staticClass: "c11"
  }, [_vm._v("1.教育思想和教学理念先进，遵循学生认知规律，反映日常教学实际。"), _c('br'), _vm._v("2.按照授课计划实施教学，关注重点、难点的解决，能够针对学习反馈及时调整教学，突出学生中心，实行因材施教。"), _c('br'), _vm._v("3.教学环境真实，满足教学需要，教学活动开展有序，教学互动深入有效，教学气氛生动活泼，学生学有所得。"), _c('br'), _vm._v("4.关注教与学行为数据采集，针对目标要求开展考核与评价。"), _c('br'), _vm._v("5.创新教学方式方法，合理运用前沿信息技术、数字化教学资源、设施设备改造传统教学，提升学习效果、提高教学与管理成效。")])]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("教学"), _c('br'), _vm._v("素养")]), _vm._v(" "), _c('td', {
    staticClass: "c11"
  }, [_vm._v("1.展现新时代职业院校教师良好的师德师风、教学能力和信息素养。"), _c('br'), _vm._v("2.教师课堂教学态度认真、严谨规范、表述清晰、亲和力强、仪态自然。"), _c('br'), _vm._v("3.教学研究深入，学术功底扎实。")])]), _vm._v(" "), _c('tr', {
    staticClass: "r1"
  }, [_c('td', {
    staticClass: "c1"
  }, [_vm._v("特色"), _c('br'), _vm._v("创新")]), _vm._v(" "), _c('td', {
    staticClass: "c11"
  }, [_vm._v("1.在落实立德树人、文化素养提升、课程思政建设等方面有行之有效的做法，能够调动学生全面深度参与，给学生深刻的学习体验。"), _c('br'), _vm._v("2.在落实国家教学标准、推进“三教”改革、运用信息技术等方面有特色、有创新。"), _c('br'), _vm._v("3.具有较大借鉴和推广价值。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce8d585c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluateManage/questionnaireServer/tkGgEvaluate.vue
// module id = 1898
// module chunks = 502